<svg:g aaColumnGroup *ngFor="let serie of series"></svg:g>
